import style from "../../Pages/ServicesDisplay.module.css";

const DetailedService = ( props) => {
    return (
      <article className={style.ServiceDetailArticle}>
        <h1>{props.heading}</h1>
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "100%",
            justifyContent: "center",
          }}
        >
          <picture>
            <img src={props.picture} alt="Loading .."></img>
          </picture>
        </div>
        <p className={style.Paragraph}>

            {props.body}
        </p>
      
      
  
       <div>
      
       </div>
      </article>
    );
  };
  
  export default DetailedService;
  